module.exports = __webpack_public_path__ + "img/card.3679c182.jpg";